import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { CURRENCIES, VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import { OUTSOURCER_PATH, addOutsourcer } from '../../api/outsourcerApi'
import { addOutsourcerAction } from '../../redux/feature/outsourcerSlice'
import CurrencyPicker from '../../components/currency/CurrencyPicker'

const OutsourcerSubmitPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newEntity, setNewEntity] = useState({
        code: "",
        name: "",
        address: "",
        phone: "",
        description: "",
        currency: null
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${OUTSOURCER_PATH}`, true)

    const onClickSubmit = () => {
        addOutsourcer(newEntity)
            .then(res => {
                dispatch(addOutsourcerAction(res.data))
                closeTab()
                toast.success('Fasoncu kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Fasoncu</label>
                <Input
                    label='Fasoncu Kodu'
                    name='code'
                    placeholder='Fasoncu kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Fasoncu Adı'
                    name='name'
                    placeholder='Fasoncu adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Telefon Numarası'
                    name='phone'
                    placeholder='Telefon numarası girin'
                    error={errors.phone}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Textarea
                    label='Adres'
                    name='address'
                    placeholder='Adres girin'
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <CurrencyPicker
                    label="Kur"
                    value={newEntity.currency}
                    onChange={(currency) => setNewEntity(prevState => ({ ...prevState, currency }))}
                    text={(newEntity.currency) || 'Kur seçin'}
                    items={CURRENCIES}
                    error={errors.currency}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default OutsourcerSubmitPage